import { PurchaseOptionType } from '@/types/productServerApi';
import useTEMPB2CFeatureBasket from '@/b2c/basket/useTEMPB2CFeatureBasket';
import useProductClickAndCollect from '@/shared/product/purchase/ui/useProductClickAndCollect';
import { computed } from 'vue';
import { useModuleConfigurator } from '@/shared/product/details/ui/module-configurator/useModuleConfigurator';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
const { addRegular, addPickAndPack, addClickAndCollect, clickAndCollectStoreId, addOrUpdateModuleConfiguration } = useTEMPB2CFeatureBasket();
const { storeId } = useProductClickAndCollect();
const { moduleConfiguratorTileData } = useModuleConfigurator();

export function useAddToBasket() {
    const relevantStoreId = computed(() => storeId.value ?? clickAndCollectStoreId.value);
    const configurationId = useRouteQuery(QueryKeys.PDPConfigurationId);

    const addToBasket = async(id: string, purchaseType: PurchaseOptionType, quantity: number = 1, relatedItemId?: number) => {
        switch (purchaseType) {
        case PurchaseOptionType.PickAndPack:
            await addPickAndPack(id, quantity, relatedItemId);
            break;
        case PurchaseOptionType.ClickAndCollect:
            if (relevantStoreId.value) {
                await addClickAndCollect(id, quantity, relevantStoreId.value, relatedItemId);
            }
            break;
        case PurchaseOptionType.ModuleConfiguration:
            await addOrUpdateModuleConfiguration(configurationId.value, moduleConfiguratorTileData.value);
            break;
        default:
            await addRegular(id, quantity, relatedItemId);
        }
    };

    return {
        addToBasket,
    };
}
